<template>
  <ul class="timeLine page_text_font" :class="theme">
    <li v-for="item in trackinfo" :key="item.Date">
      <div class="timeLineItem">
        <div class="timeLineBg"></div>
        <div class="timeLineBody">
          <div class="timeLineBodyArrow"></div>
          <div class="timeLineBodyHead">{{ item.Date }}</div>
          <div class="timeLineBodyContent">
            {{ item.StatusDescription }}
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  props: ["trackinfo", "theme"],
  data() {
    return {};
  },
};
</script>
<style scoped lang='scss'>
* {
  text-align: left;
}
ul {
  li {
    list-style: none;
  }
}
.timeLine {
  position: relative !important;
  &::before {
    content: "";
    position: absolute;
    display: block;
    width: 4px;
    background: #f5f6fa;
    top: 0;
    bottom: 0;
    margin-left: 24px;
  }
  li {
    list-style: none;
    .timeLineItem {
      .timeLineBg {
        border-radius: 50%;
        border: 5px solid #f5f6fa;
        background-color: white;
        float: left;
        position: relative;
        width: 40px;
        height: 40px;
        top: 18px;
        left: 6px;
      }
      .timeLineBody {
        position: relative;
        padding: 0 12px;
        margin-top: 20px;
        margin-left: 65px;
        background-color: #f5f6fa;
        border-radius: 4px;
        .timeLineBodyArrow {
          position: absolute;
          top: 25px;
          left: -14px;
          width: 0;
          height: 0;
          border-color: transparent #f5f6fa transparent transparent;
          border-style: solid;
          border-width: 14px 14px 14px 0;
        }
        .timeLineBodyHead {
          line-height: 44px;
          color: #999;
          font-size: 16px;
        }
        .timeLineBodyContent {
          font-size: 16px;
          width: 100%;
          padding-bottom: 12px;
          line-height: 32px;
          word-break: break-word;
        }
      }
    }
    &:first-child {
      .timeLineItem {
        .timeLineBg {
          background-image: url("~@/images/track.png");
          background-position: -0 -401px;
        }
      }
    }
  }
}
.showtime {
  &::before {
    background: #e7e7e7;
  }
  li {
    .timeLineItem {
      .timeLineBg {
        border: 5px solid #e7e7e7;
      }
      .timeLineBody {
        background-color: #e7e7e7;
        .timeLineBodyArrow {
          border-color: transparent #e7e7e7 transparent transparent;
        }
      }
    }
  }
}
</style>